__turbopack_context__.v({
  "container": "SearchItem-module__QtTgxW__container",
  "description": "SearchItem-module__QtTgxW__description",
  "icon": "SearchItem-module__QtTgxW__icon",
  "left": "SearchItem-module__QtTgxW__left",
  "score": "SearchItem-module__QtTgxW__score",
  "sectionTitle": "SearchItem-module__QtTgxW__sectionTitle",
  "title": "SearchItem-module__QtTgxW__title",
});
